<template>
  <BaseListHeader class="text-xs cursor-default">
    <div class="flex -mx-3 -my-2">
      <div class="w-16 px-3" />
      <div class="flex-1 px-3">
        <div class="flex -mx-3">
          <div
            class="flex-1 px-3 hover:underline py-2"
            @click="toggleActiveSortingOption('name').refreshRouteSorting()"
          >
            <FontAwesomeIcon
              v-if="isSortingOptionActive('name')"
              :icon="getSortingOptionValue('name') > 0 ? 'sort-alpha-down' : 'sort-alpha-down-alt'"
              class="mr-2"
            />

            Name
          </div>
          <div class="w-32 px-3 py-2">Status</div>
          <div class="w-32 px-3 py-2">In project</div>
          <div class="w-32 px-3 py-2">Is invoiced</div>
          <div
            class="w-32 px-3 text-right hover:underline py-2"
            @click="toggleActiveSortingOption('price').refreshRouteSorting()"
          >
            <FontAwesomeIcon
              v-if="isSortingOptionActive('price')"
              :icon="getSortingOptionValue('price') > 0 ? 'sort-alpha-down' : 'sort-alpha-down-alt'"
              class="mr-2"
            />

            Price
          </div>
          <div
            class="w-32 px-3 text-right hover:underline py-2"
            @click="toggleActiveSortingOption('delivery').refreshRouteSorting()"
          >
            <FontAwesomeIcon
              v-if="isSortingOptionActive('delivery')"
              :icon="
                getSortingOptionValue('delivery') > 0 ? 'sort-alpha-down' : 'sort-alpha-down-alt'
              "
              class="mr-2"
            />

            Delivery At
          </div>
          <div
            class="w-32 px-3 text-right hover:underline py-2"
            @click="toggleActiveSortingOption('created').refreshRouteSorting()"
          >
            <FontAwesomeIcon
              v-if="isSortingOptionActive('created')"
              :icon="
                getSortingOptionValue('created') > 0 ? 'sort-alpha-down' : 'sort-alpha-down-alt'
              "
              class="mr-2"
            />

            Created At
          </div>
        </div>
      </div>
    </div>
  </BaseListHeader>
</template>

<script>
import sortMixin from '@/mixins/sortMixin';

export default {
  mixins: [sortMixin],
  watch: {
    $route: 'setInitialSortingValuesFromRoute',
  },
  created() {
    this.setSortingOptions([
      'name',
      'price',
      'delivery',
      'created',
    ]).setInitialSortingValuesFromRoute(this.$route);
  },
};
</script>
